import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'value',
  pure: true
})
export class ValuePipe implements PipeTransform {

  transform(value: any, properties?: string, _default?: any): unknown {
    if (!value) return value;
    var props = properties?.split(',');
    if (!props?.length) return value;
    for (var prop of props)
      if (value?.[prop]) return value[prop];
    return _default;
  }

}
